import React, {useState} from "react"
import styles from "./index.module.scss"
import {KeyboardArrowDown} from "@mui/icons-material"
import {Menu, MenuItem} from "@mui/material"

type ERole = "merged" | "base"

interface BranchSelectorDropdownProps {
  onSelect: (val: string) => void
  value: string
  branches: string[]
  role: ERole
}

/**
 * A customized Dropdown-Menu Component for selecting branches (primarily for PullRequests)
 * @param {BranchSelectorDropdownProps} props
 * @param {(val: string) => void} props.onSelect click handler when the branch is clicked
 * @param {string} props.value the value of currently selected branch
 * @param {ERole} props.role primarily for identifying ours/theirs branches
 * @returns
 */
const BranchSelectorDropDown = (props: BranchSelectorDropdownProps) => {
  const [anchor, setAnchor] = useState<HTMLElement | null>(null)

  return (
    <>
      <div className={styles.BranchSelector}
           onClick={(e) => setAnchor(e.currentTarget)}
      >
        {props.role}: {props.value}
        <KeyboardArrowDown fontSize={"small"}/>
      </div>
      <Menu
        id={`${props.role}-branch-menu`}
        open={!!anchor}
        anchorEl={anchor}
        onClose={(e) => setAnchor(null)}
        classes={{paper: styles.MenuPaper, list: styles.MenuList}}
      >
        {
          props.branches.map((br) => (
            <MenuItem
              key={br}
              onClick={(e: any) => {
                props.onSelect(e.target.innerText)
                setAnchor(null) // So the dropdown collapses after any item is clicked
              }}
              classes={{root: styles.MenuItemRoot}}
            >
              {br}
            </MenuItem>
          ))
        }
      </Menu>
    </>
  )
}

export default BranchSelectorDropDown
